module.exports = __webpack_public_path__ + "static/media/ClexaneLogo.6c3e9a1a.png";